var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.loaded)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":'/grid-tracker/app.html'}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }